import { render, staticRenderFns } from "./expertdetail.vue?vue&type=template&id=4dee77ac&scoped=true&"
import script from "./expertdetail.vue?vue&type=script&lang=js&"
export * from "./expertdetail.vue?vue&type=script&lang=js&"
import style0 from "./expertdetail.vue?vue&type=style&index=0&id=4dee77ac&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dee77ac",
  null
  
)

export default component.exports